module.exports = __webpack_public_path__ + "static/media/1012817.1a973012.png";